// Link din emailul "comanda nefinalizata" (?reluare=TOKEN) - 12.10.2026.
// Importat PRIMUL in index.js: tokenul e scos din URL inainte de orice alt cod (GA4, sursa vizitei, react-snap),
// deci nu ajunge in analytics, istoric sau Referer. Restul parametrilor (cod, utm) raman.
try {
  const params = new URLSearchParams(window.location.search);
  const resume = params.get('reluare');
  if (resume) {
    if (/^[a-f0-9]{32}$/.test(resume)) window.__resumeDraftToken = resume;
    params.delete('reluare');
    const qs = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
  }
} catch (e) { /* fara efect */ }
